"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _decrypt = require("./decrypt");

var _UA = _interopRequireDefault(require("../UA"));

var _versionHelper = _interopRequireDefault(require("../versionHelper"));

var _IssJsBridge = _interopRequireDefault(require("../IssJsBridge"));

var _urlHelper = _interopRequireDefault(require("../urlHelper"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var cur$Version = _versionHelper["default"].cur$Version;

var RequestAdapter = function () {
  function RequestAdapter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, RequestAdapter);
    var _options$headerName = options.headerName,
        headerName = _options$headerName === void 0 ? 'encryptSwitch' : _options$headerName,
        _options$requestType = options.requestType,
        requestType = _options$requestType === void 0 ? 'fetch' : _options$requestType,
        _options$dataKey = options.dataKey,
        dataKey = _options$dataKey === void 0 ? 'data' : _options$dataKey;
    this.whitelist = window.safeWhitelist;
    this.headerName = headerName;
    this.requestType = requestType;
    this.dataKey = dataKey;
  }

  (0, _createClass2["default"])(RequestAdapter, [{
    key: "setWhitelist",
    value: function setWhitelist() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (Array.isArray(list)) this.whitelist = list;
    }
  }, {
    key: "getPathFromUrl",
    value: function getPathFromUrl() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      try {
        if (/^https?:\/\//i.test(url) || /^\/\//.test(url)) {
          var fullUrl = /^\/\//.test(url) ? "https:".concat(url) : url;
          var u = new URL(fullUrl);
          return u.pathname;
        }

        return url.split('?')[0].split('#')[0];
      } catch (error) {
        return url;
      }
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      try {
        if (this.whitelist === undefined) {
          return false;
        }

        var list = this.whitelist || [];

        if (list.length === 0) {
          return true;
        }

        var path = this.getPathFromUrl(url);
        return list.some(function (p) {
          return typeof p === 'string' && p === path;
        });
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "encryptUrlQuery",
    value: function encryptUrlQuery(url) {
      try {
        var _url$split = url.split('?'),
            _url$split2 = (0, _slicedToArray2["default"])(_url$split, 2),
            path = _url$split2[0],
            _url$split2$ = _url$split2[1],
            qs = _url$split2$ === void 0 ? '' : _url$split2$;

        if (!qs) return url;

        var encodedAll = _decrypt.AesCrypto.aesEncrypt(qs);

        return "".concat(path, "?").concat(encodeURIComponent(this.dataKey), "=").concat(encodeURIComponent(encodedAll));
      } catch (error) {
        return url;
      }
    }
  }, {
    key: "preprocess",
    value: function preprocess(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isWhitelisted(url)) {
        return {
          url: url,
          params: params
        };
      }

      if (this.requestType === 'axios') {
        var nextConfig = _objectSpread(_objectSpread({}, params), {}, {
          headers: _objectSpread({}, params.headers || {})
        });

        nextConfig.headers[this.headerName] = 'true';

        var _method = (nextConfig.method || 'get').toUpperCase();

        if (_method === 'GET') {
          var nextUrl = this.encryptUrlQuery(url);
          return {
            url: nextUrl,
            params: nextConfig
          };
        }

        if (nextConfig.data instanceof FormData) {
          try {
            var form = new FormData();

            var _iterator = _createForOfIteratorHelper(nextConfig.data.entries()),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
                    k = _step$value[0],
                    v = _step$value[1];

                form.append(k, v);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            var plain = {};

            var _iterator2 = _createForOfIteratorHelper(form.entries()),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _step2$value = (0, _slicedToArray2["default"])(_step2.value, 2),
                    _k = _step2$value[0],
                    _v = _step2$value[1];

                plain[_k] = _v;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            nextConfig.data = this.encryptString(JSON.stringify(plain));
          } catch (error) {}
        } else if (typeof nextConfig.data === 'string') {
          nextConfig.data = this.encryptString(nextConfig.data);
        } else if (nextConfig.data && (0, _typeof2["default"])(nextConfig.data) === 'object') {
          try {
            nextConfig.data = _decrypt.AesCrypto.aesEncrypt(JSON.stringify(nextConfig.data));
          } catch (error) {}
        } else if (nextConfig.body) {
          if (nextConfig.body instanceof FormData) {
            var _plain = {};

            var _iterator3 = _createForOfIteratorHelper(nextConfig.body.entries()),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _step3$value = (0, _slicedToArray2["default"])(_step3.value, 2),
                    _k2 = _step3$value[0],
                    _v2 = _step3$value[1];

                _plain[_k2] = _v2;
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            nextConfig.data = _decrypt.AesCrypto.aesEncrypt(JSON.stringify(_plain));
          } else if (typeof nextConfig.body === 'string') {
            nextConfig.data = _decrypt.AesCrypto.aesEncrypt(nextConfig.body);
          } else if ((0, _typeof2["default"])(nextConfig.body) === 'object') {
            try {
              nextConfig.data = _decrypt.AesCrypto.aesEncrypt(JSON.stringify(nextConfig.body));
            } catch (error) {}
          }

          delete nextConfig.body;
        }

        return {
          url: url,
          params: nextConfig
        };
      }

      var nextParams = _objectSpread(_objectSpread({}, params), {}, {
        headers: _objectSpread({}, params.headers || {})
      });

      nextParams.headers[this.headerName] = 'true';
      var method = (nextParams.method || 'GET').toUpperCase();

      if (method === 'GET') {
        var _nextUrl = this.encryptUrlQuery(url);

        return {
          url: _nextUrl,
          params: nextParams
        };
      }

      var rawPayload = '';
      var isFormData = false;

      if (nextParams.body instanceof FormData) {
        isFormData = true;

        try {
          var pairs = [];

          var _iterator4 = _createForOfIteratorHelper(nextParams.body.entries()),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _step4$value = (0, _slicedToArray2["default"])(_step4.value, 2),
                  _k3 = _step4$value[0],
                  _v3 = _step4$value[1];

              if (typeof _v3 === 'string') {
                var encodedKey = _k3;
                var encodedValue = _v3;
                pairs.push("".concat(encodedKey, "=").concat(encodedValue));
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          rawPayload = pairs.join('&');
          console.log('FormData转换为键值对格式 (fetch):', rawPayload);
        } catch (error) {
          rawPayload = '';
          console.log('FormData转换失败:', error);
        }
      } else if (typeof nextParams.body === 'string') {
        rawPayload = nextParams.body;
      } else if (nextParams.body && (0, _typeof2["default"])(nextParams.body) === 'object') {
        try {
          rawPayload = JSON.stringify(nextParams.body);
        } catch (error) {
          rawPayload = '';
        }
      }

      try {
        var encoded = _decrypt.AesCrypto.aesEncrypt(rawPayload);

        nextParams.body = encoded;

        if (isFormData) {
          nextParams.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
        }

        console.log('加密后的数据长度 (fetch):', encoded.length);
      } catch (error) {
        console.log('加密失败 (fetch):', error);
      }

      return {
        url: url,
        params: nextParams
      };
    }
  }, {
    key: "decryptString",
    value: function decryptString(str) {
      try {
        return _decrypt.AesCrypto.aesDecrypt(str);
      } catch (error) {
        return str;
      }
    }
  }, {
    key: "transformWhitelistedResponse",
    value: function transformWhitelistedResponse(data) {
      if (data && (0, _typeof2["default"])(data) === 'object' && typeof data[this.dataKey] === 'string') {
        try {
          var decoded = this.decryptString(data[this.dataKey]);

          try {
            data[this.dataKey] = JSON.parse(decoded);
          } catch (error) {
            data[this.dataKey] = decoded;
          }

          return data;
        } catch (error) {}
      }

      if (typeof data === 'string') {
        try {
          var _decoded = this.decryptString(data);

          try {
            return JSON.parse(_decoded);
          } catch (error) {
            return _decoded;
          }
        } catch (error) {
          return data;
        }
      }

      return data;
    }
  }, {
    key: "postprocess",
    value: function postprocess(url, data) {
      if (!this.isWhitelisted(url)) return data;

      try {
        return this.transformWhitelistedResponse(data);
      } catch (error) {
        return data;
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!RequestAdapter.__singleton) {
        RequestAdapter.__singleton = new RequestAdapter({
          requestType: 'fetch'
        });
      }

      return RequestAdapter.__singleton;
    }
  }, {
    key: "isAndroidApp",
    value: function isAndroidApp() {
      if (_urlHelper["default"].getQueryString('safeDebugH5') === 'true') {
        return true;
      }

      var appRes = false;

      try {
        appRes = _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.getServerConfig);
        appRes = appRes.data.requestEncryptSwitch;
      } catch (error) {
        return false;
      }

      return _UA["default"].env.shanSong_userApp_android && cur$Version['>=']('6.7.90') && appRes;
    }
  }, {
    key: "useFetch",
    value: function useFetch(url, params) {
      try {
        if (!RequestAdapter.isAndroidApp()) {
          return {
            url: url,
            params: params
          };
        }

        var adapter = RequestAdapter.getInstance();
        var pre = adapter.preprocess(url, params);
        return pre;
      } catch (error) {
        return {
          url: url,
          params: params
        };
      }
    }
  }, {
    key: "useResponse",
    value: function useResponse(url, data) {
      try {
        if (!RequestAdapter.isAndroidApp()) {
          return data;
        }

        var adapter = RequestAdapter.getInstance();
        return adapter.postprocess(url, data);
      } catch (error) {
        return data;
      }
    }
  }, {
    key: "useAxios",
    value: function useAxios(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      try {
        if (!RequestAdapter.isAndroidApp()) {
          return {
            url: url,
            config: config
          };
        }

        var adapter = new RequestAdapter({
          requestType: 'axios'
        });
        if (!adapter.isWhitelisted(url)) return {
          url: url,
          config: config
        };

        var next = _objectSpread(_objectSpread({}, config), {}, {
          headers: _objectSpread({}, config.headers || {})
        });

        next.headers[adapter.headerName] = 'true';
        var method = (next.method || 'get').toUpperCase();

        if (method === 'GET') {
          console.log('RequestAdapter.useAxios - GET 请求处理');
          console.log('原始 URL:', url);
          console.log('原始 params:', next.params);
          var baseUrl = url;
          var originalQs = '';

          if (url.includes('?')) {
            var parts = url.split('?');
            baseUrl = parts[0];
            originalQs = parts[1] || '';
          }

          console.log('baseUrl:', baseUrl, 'originalQs:', originalQs);
          var originalParams = new URLSearchParams(originalQs);
          var allParams = new URLSearchParams();

          var _iterator5 = _createForOfIteratorHelper(originalParams),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _step5$value = (0, _slicedToArray2["default"])(_step5.value, 2),
                  key = _step5$value[0],
                  value = _step5$value[1];

              allParams.append(key, value);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          if (next.params && (0, _typeof2["default"])(next.params) === 'object') {
            Object.keys(next.params).forEach(function (k) {
              var v = next.params[k];

              if (v !== undefined && v !== null) {
                allParams.append(k, String(v));
              }
            });
          }

          var qs = allParams.toString();
          console.log('合并后的查询串:', qs);

          if (qs) {
            try {
              var encoded = _decrypt.AesCrypto.aesEncrypt(qs);

              url = "".concat(baseUrl, "?").concat(encodeURIComponent(adapter.dataKey), "=").concat(encodeURIComponent(encoded));
              console.log('编码后的 URL:', url);
            } catch (error) {
              console.log('编码失败:', error);
              url = baseUrl;
            }
          } else {
            url = baseUrl;
          }

          next.params = {};
          delete next.url;
          return {
            url: url,
            config: next
          };
        }

        var rawPayload = '';
        var isFormData = false;

        if (next.data instanceof FormData) {
          isFormData = true;

          try {
            var pairs = [];

            var _iterator6 = _createForOfIteratorHelper(next.data.entries()),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _step6$value = (0, _slicedToArray2["default"])(_step6.value, 2),
                    k = _step6$value[0],
                    v = _step6$value[1];

                var encodedKey = k;
                var encodedValue = v;
                pairs.push("".concat(encodedKey, "=").concat(encodedValue));
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }

            rawPayload = pairs.join('&');
            console.log('FormData转换为键值对格式:', rawPayload);
          } catch (error) {
            rawPayload = '';
          }
        } else if (typeof next.data === 'string') {
          rawPayload = next.data;
        } else if (next.data && (0, _typeof2["default"])(next.data) === 'object') {
          try {
            rawPayload = JSON.stringify(next.data);
          } catch (error) {
            rawPayload = '';
          }
        } else if (next.params && (0, _typeof2["default"])(next.params) === 'object') {
          try {
            rawPayload = JSON.stringify(next.params);
          } catch (error) {
            rawPayload = '';
          }

          delete next.params;
        }

        try {
          var _encoded = _decrypt.AesCrypto.aesEncrypt(rawPayload);

          next.data = _encoded;

          if (isFormData) {
            next.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
          }

          console.log('加密后的数据长度:', _encoded.length);
        } catch (error) {
          console.log('加密失败:', error);
        }

        delete next.url;
        return {
          url: url,
          config: next
        };
      } catch (error) {
        return {
          url: url,
          config: config
        };
      }
    }
  }]);
  return RequestAdapter;
}();

exports["default"] = RequestAdapter;
(0, _defineProperty2["default"])(RequestAdapter, "AesCrypto", _decrypt.AesCrypto);